<template>
  <div class="">
    <ssam-talk-filter-link
        :filterLayout="filterLayout"
        :filterData="filterSet.filter"
        :paginationData="filterSet.page"
        :category="category"
    ></ssam-talk-filter-link>
    <ssam-talk-list-link
        :listLayout="listLayout"
        :paginationData="filterSet.page"
        :ssam-talk-data="List"
    ></ssam-talk-list-link>
    <pagination-link
        :paginationLayout="paginationLayout"
        :paginationData="filterSet.page"
    ></pagination-link>
  </div>
</template>

<script>

import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import ssamtalkUtil from "@/components/ssamtalk/ssamtalkUtil";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";
import PaginationLink from "@/components/ssamtalk/link/PaginationLink.vue";
import SsamTalkListLink from "@/components/ssamtalk/link/SsamTalkListLink.vue";
import SsamTalkFilterLink from "@/components/ssamtalk/link/SsamTalkFilterLink.vue";
import EventBus from "@/utils/event-bus";

const {filterConfig} = ssamtalkUtil;
export default {
  name: "SsamTalkListComponent",
  mixins: [filterMixins, listMixins, ssamtalkUtil, alertMixins],
  components: {SsamTalkFilterLink, SsamTalkListLink, PaginationLink},
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      setSort: this.setSort,
      ssamTalkListSetData: this.setData,
      deleteFunc: this.runDeleteConfirm,
    };
  },
  props: {
    ssamTalkType: '',
    ssamTalkKey:0,
  },
  data() {
    return {
      filterLayout: "",
      listLayout: "",
      paginationLayout: "",

      getFunc: "",
      getCategoryFunc: '',
      listApiParamSet: {},
      pageRow: 10,
      paginationType: "",
      deleteKeyName: "",
      deleteFunc: "",
      deleteApiParamSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      isCategory: false,
      category: [],

      selectArr: [],
      deleteIndex: 0,
      DeleteClass: null,
      deleteLastIndex: 0,
    };
  },
  created() {
    this.initConfig();
    this.setFilterConfig(filterConfig);
    this.setParserType("url", this.$route.fullPath);
  },
  mounted() {
    this.getList(true);
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setData(type, value) {
      this[type] = value;
    },
    initConfig() {
      let config = this.returnSsamTalkConfig(this.ssamTalkType);
      this.listLayout = config.listLayout;
      this.filterLayout = config.filterLayout;
      this.paginationLayout = config.paginationLayout;

      this.getFunc = config.getFunc;
      this.getCategoryFunc = config.getCategoryFunc;
      this.listApiParamSet = config.listApiParamSet;
      this.pageRow = config.pageRow;
      this.paginationType = config.paginationType;
      this.keyName = config.keyName;

      this.deleteKeyName = config.deleteKeyName;
      this.deleteFunc = config.deleteFunc;
      this.deleteApiParamsSet = config.deleteApiParamsSet;
      this.deleteSuccessType = config.deleteSuccessType;
      this.deleteFailTypes = config.deleteFailTypes;

      this.isCategory = config.isCategory;
      if (config.pageRow && config.pageRow !== this.filterSet.page.size) {
        this.pageRow = config.pageRow;
        this.filterSet.page.size = config.pageRow;
        this.pageClass.setterPage("size", this.pageRow);
      }

      if(this.ssamTalkKey !==0){
        this.listApiParamSet[this.keyName] = this.ssamTalkKey;
      }
      let listOptions = {
        url: this.$api.$ssamtalk[this.getFunc],
        defaultParams: this.listApiParamSet,
      };

      this.initList("ssamTalk", listOptions);
      this.newDeleteClass();
      if (this.isCategory === true) {
        this.getCategory();
      }
    },
    newDeleteClass() {
      if (!util.isEmpty(this.deleteFunc)) {
        let deleteOptions = {
          func: this.$api.$ssamtalk[this.deleteFunc],
          apiParamSet: this.deleteApiParamsSet,
          keyName: this.deleteKeyName,
          successType: this.deleteSuccessType,
          errorTypes: this.deleteFailTypes,
          afterFunc: this.deleteAfterFunc,
        };
        this.DeleteClass = new DeleteClass(deleteOptions);
      }
    },
    getCategory() {
      let params = {ip: 0};
      this.$api.$ssamtalk[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
        this.category = res.List;
      })
    },

    runDeleteConfirm() {
      if (this.selectArr.length === 0) {
        this.errorAlert('목록을 선택해주세요.');
        return false;
      }
      this.createConfirm({
        content: '정말 삭제하시겠습니까?',
        confirm: () => {
          this.deleteIndex = 0;
          this.deleteLastIndex = this.selectArr.length - 1;
          this.runDelete();
        }
      })
    },
    runDelete() {
      EventBus.$emit('apiLoading',true);
      this.DeleteClass.runDelete(this.selectArr[this.deleteIndex]);
    },
    deleteAfterFunc() {
      if (this.deleteIndex < this.deleteLastIndex) {
        this.deleteIndex = this.deleteIndex + 1;
        this.runDelete()
      } else {
        EventBus.$emit('apiLoading',false);
        this.createAlert({
          content: '삭제되었습니다.',
          hide: () => {
            this.deleteIndex = 0;
            this.getList();
          }
        })
      }
    },

  },
  watch: {},
};
</script>
